import{HttpInterceptor, HttpRequest, HttpHandler}from'@angular/common/http'
import {Injectable}from'@angular/core'
import {MentorAuthService}from'./mentor-auth.service'
@Injectable()
export class MentorAuthInterceptor implements HttpInterceptor{
    constructor(private mentorAuthService:MentorAuthService){}
    intercept(req: HttpRequest<any>, next: HttpHandler) {
        const token=this.mentorAuthService.getToken();
        const authRequest=req.clone({
            headers:req.headers.set('MentorAuthorization',"Bearer "+token)
        })
        return next.handle(authRequest)
    }
}